import request from "@/plugins/axios";
import { getTreeItem } from "@/utils/tools";

/**
 * 获取边界
 * @param Number region 区域 Code
 */
export function getBoundary(id) {
  return request.get(`/prod/region/geojson/${id}`);
}

/**
 * 获取所有产品
 */
export function getAllProduct() {
  return request.get("/prod/product/list-visible");
}

/**
 * 获取产品详情
 */
export function getProduct(id) {
  return request.get("/prod/product/get", { params: { id } });
}

/**
 * 获取产品成果列表
 */
export function getAllProductResult(params) {
  return new Promise((resolve) => {
    request.get("/prod/product-result/page-app", { params }).then((res) => {
      if (res && res.data) {
        const regions = JSON.parse(localStorage.getItem("regions"));
        const { lon, lat, vertexBbox } = getTreeItem(regions, params.regionId);
        res.data.list = res.data.list.map((item) => ({
          ...item,
          thumb: item.thumb
            ? process.env.VUE_APP_THUMB + item.thumb
            : require("@/assets/images/common/thumb.png"),
          text: item.productTimeCn,
        }));
        res.data.center = [lon, lat];
        res.data.extent = vertexBbox
          .slice(4, -1)
          .split(",")
          .map((item) => item.split(" "))
          .reduce((pre, cur) => pre.concat(cur))
          .map((item) => item * 1);
      }
      resolve(res.data);
    });
  });
}

/**
 * 根据成果 ID 获取详情
 * @param {*} id 成果ID
 * @returns
 */
export function getProductResult({ id, regionId }) {
  return new Promise((resolve) => {
    request
      .get(`/prod/product-result/get-data/${id}/${regionId}`)
      .then((res) => {
        if (res && res.data) {
          const regionsDict =
            JSON.parse(localStorage.getItem("regionsDict")) || {};
          const featuresDict =
            JSON.parse(localStorage.getItem("featuresDict")) || {};
          const result = {
            layer: res.data.layer ? res.data.layer.code : "",
            hdLayer: res.data.layerRgb ? res.data.layerRgb.code : "",
            legends: res.data.legends,
            currentDataset:
              res.data.currentDataset !== null
                ? {
                    ...res.data.currentDataset,
                    regionName: regionsDict[res.data.currentDataset.regionId],
                    cropName: featuresDict[res.data.currentDataset.cropId],
                  }
                : null,
            dataset: res.data.dataset.map((item) => ({
              ...item,
              regionName: regionsDict[item.regionId],
              cropName: featuresDict[item.cropId],
            })),
          };

          resolve(result);
        }
      });
  });
}

/**
 * 获取所有区域
 */
export function getAllRegion() {
  return request.get("/prod/region/list-all-simple");
}

/**
 * 获取区域内的自定义区域列表
 */
export function getCustomRegion(regionId) {
  return new Promise((resolve) => {
    request
      .get("/prod/region-custom/listByRegion", { params: { regionId } })
      .then(({ data }) => {
        resolve(
          data.map((item) => ({
            ...item,
            visible: false,
            center: [item.lon, item.lat],
            extent: item.vertexBbox.split(",").map((item) => item * 1),
            label: item.name,
          }))
        );
      });
  });
}

/**
 * 农事提醒
 */
export function getRemind(params) {
  return new Promise((resolve) => {
    request.get("/farm/reminder/page", { params }).then(({ data }) => {
      const regionsDict = JSON.parse(localStorage.getItem("regionsDict")) || {};
      const featuresDict =
        JSON.parse(localStorage.getItem("featuresDict")) || {};
      resolve(
        data.list.map((item) => ({
          ...item,
          regionName: regionsDict[item.regionId],
          featureName: featuresDict[item.cropId],
        }))
      );
    });
  });
}

/**
 * 获取所有设备
 */
export function getAllDevice(regionId) {
  return request.get(`/farm/iot-equipment/list/${regionId}`);
}

/**
 * 获取所有地物
 */
export function getAllFeature() {
  return request.get("/prod/surface-feature/list-all-crop");
}
/**
 * 获取地物数据表格用
 */
export function getAllFeatureList(params) {
  return request.get("/prod/surface-feature/list", { params });
}
/**
 * 获取服务报告
 */
export function getReport(params) {
  return request.get("/prod/report/page", { params });
}

/**
 * 根据成果 ID 和经纬度获取地块详情
 */
export function getResultLandInfo(params) {
  return request.get("/prod/product-result/getByPos", { params });
}

/**
 * 根据经纬度获取地块详情
 */
export function getLandInfo(params) {
  return request.get("/land/land/getByPos", { params });
}

/**
 * 成果下载
 */
export function getProductFile(id) {
  return request.get(`/prod/product-result/download/${id}`, {
    responseType: "blob",
  });
}

/**
 * 根据 ID 获取大屏数据
 * @param {Object} params
 * @param {Number} params.pos
 * 1 - 统计数据
 * 2 - 作物分布
 * 3 - 作物长势
 * 4 - 作物产量
 * 5 - 降雨
 * 6 - 气温
 * 7 - 地温
 * 8 - 土壤湿度
 * 9 - 病虫害
 * 10 - 灾害
 */
export function getScreen(params) {
  return request.get("/screen/area-info/get-data", { params });
}

// 获得高标准农田项目信息
export function getFieldProject(id) {
  return request.get("/high/field-project/get?id=" + id);
}

// 获得高标准农田项目信息分页
export function getFieldProjectPage(params) {
  return request("/high/field-project/project-list", { params });
}

// 获得高标准农田项目信息分页
export function getDateListPage(params) {
  return request("/high/field-project/query-project-timeline", { params });
}

//根据高标准农田项目id和日期查询项目边界
export function getLandExtent(params) {
  return request("/high/field-land/queryExtent", { params });
}

//根据经纬度获取地块信息
export function getLandInfoByCood(params) {
  return request("/high/field-land/getByPos", { params });
}

//根据地块id获取地块信息
export function getLandInfoByLandId(params) {
  return request("/high/field-land/get", { params });
}

//分页查询地块（表格用）
export function getTableData(params) {
  return request("/high/field-land/page", { params });
}

//分页查询时间轴
export function getTimeList(params) {
  return request("/prod/product-result/page-project-data", { params });
}

// 统计数据查询【非粮监测、作物分布、长势监测
export function getResultTableData(params) {
  return request("/prod/product-result/get-project-data", { params });
}

//获得产品的图例列表（耕地质量模块）
export function getLandQualityLegend(params) {
  return request("/prod/product-legend/select-by-product", { params });
}

//获取产品的样式名称（耕地质量模块）
export function getLandQualityStyle(params) {
  return request("/prod/product-style/get-style-name", { params });
}

//根据高标准id查询设备列表
export function getEquipment(params) {
  return request("/farm/iot-equipment/list-by-project",  { params });
}

//查询字典
export function getDicts(params) {
  return request("/system/dict-data/page",  { params });
}

//获取个人信息
export function getPersonal(params) {
  return request("http://202.110.121.232:81/henan/nolog/account/checkUserLogin");
}

